import { HTMLAttributes, memo, PropsWithChildren } from 'react';
import { StyledPanel } from './panel.styled';

export const Panel = memo(
  (props: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) => {
    return <StyledPanel {...props} />;
  }
);
